"use strict";
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { jsx, jsxs } from "react/jsx-runtime";
import _ from "underscore";
import Blocker from "./blocker";
const defaultChildren = /* @__PURE__ */ jsx("div", {});
export default function WaitingSpinner(_a) {
  var _b = _a, {
    children = defaultChildren
  } = _b, props = __objRest(_b, [
    "children"
  ]);
  function spinner() {
    return /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsxs("div", { className: "cg-busy-default-sign show_for_non_reskin", children: [
        /* @__PURE__ */ jsx("div", { className: "cg-busy-default-spinner", children: _.map(_.range(12), spinnerBar) }),
        /* @__PURE__ */ jsx("div", { className: "cg-busy-default-text", children: "Please Wait..." })
      ] }),
      /* @__PURE__ */ jsx("div", { className: "v3-spinner-container show_for_reskin", children: /* @__PURE__ */ jsxs(
        "svg",
        {
          width: "64",
          height: "64",
          viewBox: "0 0 64 64",
          fill: "none",
          className: "v3-spinner",
          children: [
            /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", { id: "clip0_1273_124830", children: /* @__PURE__ */ jsx("rect", { width: "64", height: "64", fill: "white" }) }) }),
            /* @__PURE__ */ jsxs("g", { clipPath: "url(#clip0_1273_124830)", children: [
              /* @__PURE__ */ jsx(
                "path",
                {
                  className: "v3-spinner-quadrant-1",
                  d: "M57.6926 23.1432L40.8009 23.1432L40.8009 6.25149L34.5466 0L34.5466 29.3983L63.9448 29.3983L57.6926 23.1432Z",
                  fill: "white"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  className: "v3-spinner-quadrant-2",
                  d: "M57.6926 40.8041L40.8009 40.8041L40.8009 57.6966L34.5466 63.9481L34.5466 34.5498L63.9448 34.5498L57.6926 40.8041Z",
                  fill: "white"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  className: "v3-spinner-quadrant-3",
                  d: "M6.25149 23.1432L23.1432 23.1432L23.1432 6.25149L29.3983 0L29.3983 29.3983L0 29.3983L6.25149 23.1432Z",
                  fill: "#00A4BF"
                }
              ),
              /* @__PURE__ */ jsx(
                "path",
                {
                  className: "v3-spinner-quadrant-4",
                  d: "M6.25149 40.8041L23.1432 40.8041L23.1432 57.6966L29.3983 63.9481L29.3983 34.5498L0 34.5498L6.25149 40.8041Z",
                  fill: "white"
                }
              )
            ] })
          ]
        }
      ) })
    ] });
  }
  const spinnerBar = (index) => {
    return /* @__PURE__ */ jsx("div", { className: "bar" + (index + 1) }, index);
  };
  return /* @__PURE__ */ jsx(
    Blocker,
    {
      "data-component": "WaitingSpinner",
      modalView: props.when ? spinner() : void 0,
      children
    }
  );
}
